// extracted by mini-css-extract-plugin
export default {"as":"index_as__v4Rx5"};